import * as React from 'react';
import { observer } from 'mobx-react';
import * as classnames from 'classnames';
import styled from 'styled-components';
import { ContentSpacing } from '@estee/elc-base-theme';
import { reviewsTextTheme } from '../theme/default-theme';
import { REVIEWS_NUMBER, REVIEW_NUMBER_LABEL } from '../constants/DataTestIds';

export interface IReviews {
    className?: string;
    reviewsNumber: number;
    reviewsNumberLabel?: string;
    showReviewsNumberLabel?: boolean;
}

const ReviewsNumberElement = styled.span`
    display: block;
    ${reviewsTextTheme};
`;

const ReviewsNumberWrapper = styled.span`
    display: inline-block;
    margin: 0 ${ContentSpacing.space8};
    vertical-align: middle;
`;

export const ReviewsNumber = observer((props: IReviews) => {
    const wrapperClassNames = classnames(
        'elc-rating-reviews',
        'js-rating-reviews',
        props.className
    );
    const reviewsNumberClassNames = classnames('elc-reviews-number', 'js-reviews-number');
    const reviewsNumberLabelClassnames = classnames(
        'elc-reviews-number-label',
        'js-reviews-number-label'
    );
    const parenthesisClassName = classnames('elc-reviews-parenthesis');
    const { reviewsNumberLabel, reviewsNumber, showReviewsNumberLabel } = props;

    return (
        <ReviewsNumberWrapper className={wrapperClassNames} data-test-id={REVIEWS_NUMBER}>
            <ReviewsNumberElement className={reviewsNumberClassNames}>
                <span className={parenthesisClassName}>(</span>
                <span>{reviewsNumber}</span>
                {reviewsNumberLabel && showReviewsNumberLabel && (
                    <span
                        className={reviewsNumberLabelClassnames}
                        data-test-id={REVIEW_NUMBER_LABEL}
                    >
                        {reviewsNumberLabel}
                    </span>
                )}
                <span className={parenthesisClassName}>)</span>
            </ReviewsNumberElement>
        </ReviewsNumberWrapper>
    );
});
